export default __webpack_public_path__ + "static/media/rocktobot.4823555e.png";